import React from 'react';
import { Loader, BaasicInput } from 'core/components';
import { defaultTemplate } from 'core/hoc';

function CreateBoxTemplate({ createBoxViewStore, t }) {
	const { form, loading, createBox, onBack } = createBoxViewStore;
	if (loading) return <Loader />;
	return (
		<div className="container--fluid">
			<form className="form" onSubmit={form.onSubmit}>
				<div>
					<div>
						<div className="ReactModal__header">
							<h3 className="spc--bottom--sml">{t('PRODUCT.WIZARD.BOXMODAL')}</h3>
						</div>
						<div className="ReactModal__body">
							<BaasicInput autoFocus field={form.$('name')} />
							<BaasicInput field={form.$('boxHeight')} />
							<BaasicInput field={form.$('boxWidth')} />
							<BaasicInput field={form.$('boxLength')} />
						</div>
						<div className="ReactModal__footer">
							<button
								className="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
								type="button"
								onClick={createBox}
							>
								{t('SAVE')}
							</button>
							<button className="btn btn--med btn--secondary spc--bottom--sml" type="button" onClick={onBack}>
								{t('BACK')}
							</button>
							{form.error && <p className="type--color--warning spc--bottom--sml">{t(form.error)}</p>}
						</div>
					</div>
				</div>
			</form>
		</div>
	);
}

export default defaultTemplate(CreateBoxTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/pages/CreateBoxTemplate.jsx